type TranslatePopoverCopy = (key: string, options: { count: number }) => string

const LISTING_SECTIONS = new Set(['purchase_listings', 'rental_listings'])

export const getVectorTilePopoverCopy = (
  section: string | null | undefined,
  count: number,
  translate: TranslatePopoverCopy
) => {
  const isListingSection = section && LISTING_SECTIONS.has(section)

  return {
    title: translate(
      isListingSection
        ? 'map.vectorTile.listingsAtLocation'
        : 'map.vectorTile.featuresAtLocation',
      { count }
    ),
    scrollHint: translate(
      isListingSection
        ? 'map.vectorTile.scrollListings'
        : 'map.vectorTile.scrollFeatures',
      { count }
    ),
  }
}
